import React from "react";
import { Box, Typography, Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as LogoIcon } from "../assets/images/logo-icon-branca.svg";

const LogoutLayoutWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        minHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Lado Esquerdo - Gradiente com Logo e Mensagens */}
      <Box
        sx={{
          flex: { xs: "0 0 60%", md: 1 },
          minHeight: { xs: "60vh", md: "100vh" },
          background: `
            radial-gradient(circle at 85% 15%, #382875 0%, transparent 65%),
            radial-gradient(circle at 50% 30%, #34276a 0%, transparent 70%),
            linear-gradient(135deg, #1b1643 0%, #34276a 50%, #382875 100%)
          `,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          px: { xs: 3, md: 6 },
          py: { xs: 4, md: 8 },
        }}
      >
        {/* Overlay sutil para melhor legibilidade */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.15)",
            zIndex: 1,
          }}
        />

        {/* Conteúdo */}
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 4,
            maxWidth: "500px",
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              width: { xs: "150px", md: "200px" },
              height: { xs: "150px", md: "200px" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LogoIcon
              style={{
                width: "100%",
                height: "100%",
                filter: "drop-shadow(0 8px 32px rgba(255, 255, 255, 0.3))",
              }}
            />
          </Box>

          {/* Mensagens */}
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2rem", md: "3rem" },
                color: "#ffffff",
                fontWeight: "700",
                textAlign: "center",
                lineHeight: 1.2,
                mb: 2,
                textShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
              }}
            >
              {t("logoutMessage")}
            </Typography>

            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.3rem", md: "1.8rem" },
                color: "#93f090",
                fontWeight: "500",
                textAlign: "center",
                opacity: 0.95,
                textShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              {t("back_soon")}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Lado Direito - Elementos Flutuando */}
      <Box
        sx={{
          flex: { xs: "0 0 40%", md: 1 },
          minHeight: { xs: "40vh", md: "100vh" },
          backgroundColor: "#f8f9fa",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 3, md: 6 },
          py: { xs: 3, md: 8 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default LogoutLayoutWrapper;
